<div class="min-h-screen bg-slate-50">
  <div class="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
    <a
      routerLink="/writing"
      class="mb-6 inline-flex items-center gap-2 text-base font-medium text-slate-500 transition-colors hover:text-slate-900"
    >
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
      返回写作
    </a>

    <h1 class="mb-6 font-display text-2xl font-bold text-slate-800">练习记录</h1>

    @if (loading()) {
      <div class="flex items-center justify-center py-20">
        <p class="flex items-center gap-3 text-lg font-medium text-slate-500">
          <svg class="h-5 w-5 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          加载中...
        </p>
      </div>
    } @else if (error()) {
      <div class="rounded-lg border border-rose-200 bg-rose-50 px-6 py-4 text-rose-700">
        {{ error() }}
      </div>
    } @else if (items().length === 0) {
      <div class="rounded-xl border border-slate-200 bg-white p-12 text-center shadow-sm">
        <p class="text-slate-500">暂无练习记录</p>
        <a
          routerLink="/writing/topics"
          class="mt-4 inline-flex items-center gap-2 rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          开始练习
        </a>
      </div>
    } @else {
      <ul class="space-y-4">
        @for (item of items(); track item.combinationId) {
          <li>
            <button
              type="button"
              (click)="openResult(item)"
              class="w-full rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition-all hover:border-slate-300 hover:shadow-md"
            >
              <div class="flex flex-wrap items-center justify-between gap-3">
                <div>
                  <span class="font-semibold text-slate-800">{{ item.combinationId }}</span>
                  @if (item.overallNclc != null) {
                    <span class="ml-2 rounded border border-blue-200 bg-blue-50 px-2 py-0.5 text-sm font-medium text-blue-700">
                      NCLC {{ item.overallNclc }}
                    </span>
                  }
                </div>
                <span class="text-sm text-slate-500">{{ formatDate(item.lastUpdatedAt) }}</span>
              </div>
              <div class="mt-2 flex flex-wrap gap-2">
                @for (key of ['task1', 'task2', 'task3']; track key) {
                  @if (item.tasks[key]; as t) {
                    <span
                      class="rounded-full border px-2.5 py-0.5 text-xs font-medium"
                      [class.border-emerald-200]="t.status === 'graded'"
                      [class.bg-emerald-50]="t.status === 'graded'"
                      [class.text-emerald-700]="t.status === 'graded'"
                      [class.border-rose-200]="t.status === 'uncompleted'"
                      [class.bg-rose-50]="t.status === 'uncompleted'"
                      [class.text-rose-700]="t.status === 'uncompleted'"
                    >
                      {{ key === 'task1' ? 'Tâche 1' : key === 'task2' ? 'Tâche 2' : 'Tâche 3' }}:
                      {{ t.status === 'graded' ? '已评分' : '未完成' }}
                    </span>
                  }
                }
              </div>
            </button>
          </li>
        }
      </ul>

      @if (lastKey()) {
        <div class="mt-6 text-center">
          <button
            type="button"
            (click)="loadMore()"
            [disabled]="loading()"
            class="rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-200 disabled:opacity-50"
          >
            加载更多
          </button>
        </div>
      }
    }
  </div>
</div>
